"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Bolt: function() {
        return Bolt;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Bolt = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.372 1.07189C13.795 1.24148 14.0499 1.6756 13.9917 2.1276L13.1367 8.77786H19.0108C20.2408 8.77786 20.948 10.1768 20.2187 11.1673L11.8051 22.593C11.5349 22.96 11.0508 23.0978 10.6278 22.9283C10.2048 22.7587 9.94996 22.3246 10.0081 21.8726L10.8631 15.2223H4.98902C3.75902 15.2223 3.05183 13.8233 3.78116 12.8329L12.1947 1.40713C12.4649 1.04016 12.949 0.90231 13.372 1.07189ZM5.97814 13.2223H11.9999C12.2874 13.2223 12.5609 13.346 12.7507 13.5618C12.9406 13.7776 13.0284 14.0647 12.9917 14.3498L12.4841 18.298L18.0217 10.7779H11.9999C11.7125 10.7779 11.4389 10.6542 11.2491 10.4383C11.0592 10.2225 10.9714 9.93543 11.0081 9.65033L11.5157 5.70216L5.97814 13.2223Z",
        fill: "currentColor"
    })
}), "Bolt");
const _default = Bolt;
